import { api } from "@/api/client";
import type {
  CreditCostDto,
  CreditPackDto,
  WalletMe,
  WalletSubscription,
} from "@/types/api";

export async function getWalletMe(): Promise<WalletMe> {
  return api<WalletMe>("/wallet/me");
}

export async function getWalletSubscription(): Promise<WalletSubscription> {
  return api<WalletSubscription>("/wallet/subscription");
}

export async function listCreditCosts(): Promise<CreditCostDto[]> {
  return api<CreditCostDto[]>("/wallet/costs");
}

export async function listCreditPacks(): Promise<CreditPackDto[]> {
  return api<CreditPackDto[]>("/wallet/packs", { skipAuth: true });
}

export async function redeemChargeCode(
  code: string,
): Promise<{ balance: number; creditsAdded: number }> {
  return api("/wallet/charge-codes/redeem", {
    method: "POST",
    body: JSON.stringify({ code }),
  });
}

export async function purchasePack(packKey: string): Promise<unknown> {
  return api(`/wallet/packs/${encodeURIComponent(packKey)}/purchase`, {
    method: "POST",
  });
}

export async function subscribePlan(planKey: string): Promise<unknown> {
  return api(`/wallet/subscribe/${encodeURIComponent(planKey)}`, {
    method: "POST",
  });
}

export async function cancelSubscription(): Promise<{
  status: string;
  cancelAtPeriodEnd: boolean;
}> {
  return api("/wallet/subscriptions/cancel", { method: "POST" });
}

export async function resumeSubscription(): Promise<{
  status: string;
  cancelAtPeriodEnd: boolean;
}> {
  return api("/wallet/subscriptions/resume", { method: "POST" });
}
